// import React from 'react';

// function MonthlyProjectStatusReport() {
//   const powerBiUrl = process.env.REACT_APP_Monthly_Proj_Sts_Report;
//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  MonthlyProjectStatusReport;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function MonthlyProjectStatusReport() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='Monthly_Proj_Sts_Report';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default MonthlyProjectStatusReport;
